import { api } from "./client";
import { apiRoutes } from "util/apiRoutes";

export interface SaveStateResponse {
  isSaved: boolean;
  isCollected: boolean;
  collectionCount: number;
  isActive: boolean;
}

export const saveApi = {
  getStatus: async (entityType: string, entityId: number): Promise<SaveStateResponse> => {
    const response = await api.get<SaveStateResponse>(apiRoutes.saves.statusByEntity(entityType, entityId));
    return response.data;
  },

  save: async (entityType: string, entityId: number): Promise<Record<string, unknown>> => {
    const response = await api.post<Record<string, unknown>>(apiRoutes.saves.root, {
      entityType,
      entityId,
    });
    return response.data;
  },

  unsave: async (entityType: string, entityId: number): Promise<Record<string, unknown>> => {
    const response = await api.delete<Record<string, unknown>>(apiRoutes.saves.byEntity(entityType, entityId));
    return response.data;
  },
};
